import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Switches the whole app between the default look and the 8-bit skin.
 */
interface ThemeToggleProps {
  className?: string;
  /**
   * Keep the label visible at every width. The compact bar can get away with
   * the icon alone, but a full-width row in the mobile menu showing only an
   * emoji gives no clue what it does.
   */
  alwaysShowLabel?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '', alwaysShowLabel = false }) => {
  const { isRetro, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isRetro ? 'Switch to the normal look' : 'Switch to 8-bit mode'}
      aria-pressed={isRetro}
      aria-label={isRetro ? 'Switch to the normal look' : 'Switch to 8-bit mode'}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-gray-300 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors text-sm ${className}`}
    >
      <span aria-hidden="true">{isRetro ? '🌈' : '👾'}</span>
      <span className={`${alwaysShowLabel ? '' : 'hidden sm:inline'} font-medium`}>
        {isRetro ? 'Normal' : '8-bit'}
      </span>
    </button>
  );
};

export default ThemeToggle;
